// Standard Shopify Ajax forms: POST the item first, then render the response.
(() => {
  if (window.PocketCart) return;
  const roots = () => [...document.querySelectorAll('[data-cart-section]')], rules = new Map();
  let config = {}, tail = Promise.resolve(), pending = 0, viewVersion = 0;
  try { config = JSON.parse(document.querySelector('[data-pocket-cart-config]')?.textContent || '{}'); } catch {}
  const route = name => config.routes?.[name] || (window.Shopify?.routes?.root || '/') + name;
  function notice(text, error = false) {
    roots().forEach(current => {
      const area = current.querySelector('[data-cart-message]');
      if (area) { area.textContent = text; area.setAttribute('role', error ? 'alert' : 'status'); }
    });
    const live = document.querySelector('[data-bag-announcement]'); if (live) live.textContent = text;
  }
  function checkoutState() {
    document.querySelectorAll('[data-pocket-checkout]:not([data-route-cloned-button]):not([data-route-copy])').forEach(button => { button.disabled = pending > 0; });
    roots().forEach(current => current.setAttribute('aria-busy', String(pending > 0)));
  }
  // Order customer clicks; there are no cart reads or comparisons before a POST.
  function mutate(task) {
    pending++; checkoutState();
    const job = tail.then(task, task);
    tail = job.catch(() => {});
    return job.finally(() => { pending--; checkoutState(); });
  }
  async function post(name, body) {
    const response = await fetch(route(name), {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Shopify could not add this item.');
    return data;
  }
  function disableForm(form) {
    const states = [...form.querySelectorAll('button,input,select,textarea')].map(node => [node, node.disabled]);
    states.forEach(([node, disabled]) => { node.dataset.cartDisabled = String(disabled); node.disabled = true; });
    return () => states.forEach(([node, disabled]) => { node.disabled = disabled; delete node.dataset.cartDisabled; });
  }
  function shippingProgress(cart, current) {
    const bar = current.querySelector('[data-free-shipping]'); if (!bar) return;
    const limit = Number(bar.dataset.shippingLimit);
    bar.hidden = cart.currency !== 'USD' || cart.item_count === 0 || cart.requires_shipping === false || !Number.isFinite(limit) || limit <= 0;
    if (bar.hidden) return;
    const total = Math.max(0, cart.total_price), remaining = Math.max(0, limit - total);
    const heading = bar.querySelector('[data-shipping-heading]');
    const headingText = remaining === 0 ? bar.dataset.headingReached : bar.dataset.headingPending;
    if (heading && heading.textContent !== headingText) heading.textContent = headingText;
    const percent = Math.min(100, total / limit * 100);
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: 'USD' }).format(value / 100);
    const message = remaining === 0 ? 'You’ve reached the free US shipping minimum!' : `Add ${money(remaining)} more for free US shipping.`;
    const label = bar.querySelector('[data-shipping-message]'); if (label.textContent !== message) label.textContent = message;
    const meter = bar.querySelector('[data-shipping-meter]');
    meter.setAttribute('aria-valuenow', String(Math.round(percent)));
    meter.setAttribute('aria-valuetext', `${money(total)} of ${money(limit)}`);
    bar.querySelector('[data-shipping-fill]').style.width = `${percent}%`;
  }
  function counts(cart) {
    roots().forEach(current => shippingProgress(cart, current));
    document.querySelectorAll('[data-cart-heading]').forEach(heading => {
      const text = cart.item_count === 0 ? heading.dataset.emptyHeading : heading.dataset.filledHeading;
      if (heading.textContent !== text) heading.textContent = text;
    });
    document.querySelectorAll('#count,[data-bag-count]').forEach(node => { node.textContent = String(cart.item_count); });
  }

  function element(tag, className, text, attributes = {}) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    Object.entries(attributes).forEach(([key, value]) => { if (value !== undefined && value !== null) node.setAttribute(key, String(value)); });
    return node;
  }
  function captureRules() {
    document.querySelectorAll('[data-quick-add] button[name="id"]').forEach(button => {
      rules.set(button.value, { min: Number(button.dataset.quantity) || 1, increment: Number(button.dataset.increment) || 1, max: button.dataset.max || '' });
    });
    document.querySelectorAll('[data-cart-line]').forEach(row => {
      const input = row.querySelector('[name="updates[]"]');
      if (input) rules.set(row.dataset.variantId, { min: Number(input.min) || 1, increment: Number(input.step) || 1, max: input.max });
    });
  }
  // Render Shopify’s cart response, retaining the customer's locale,
  // actual line keys, discounts, and totals.
  function renderFromCart(cart, current) {
    const content = current.querySelector('[data-cart-content]');
    if (!content) return;
    const labels = current.dataset;
    const format = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cart.currency || 'USD' });
    const money = cents => format.format(Number(cents) / 100);
    content.replaceChildren();
    current.dataset.cartCount = String(cart.item_count); current.dataset.cartTotal = String(cart.total_price);
    const cartForm = current.querySelector('[data-cart-form]');
    const checkout = current.querySelector('[data-cart-checkout]');
    const empty = current.querySelector('[data-cart-empty]');
    if (cartForm) cartForm.hidden = cart.items.length === 0;
    if (checkout) checkout.hidden = cart.items.length === 0;
    if (empty) empty.hidden = cart.items.length > 0;
    if (cart.items.length) {
      const form = content;
      cart.items.forEach((item, index) => {
        const row = element('div', 'bag-row', undefined, { 'data-cart-line': index + 1, 'data-line-key': item.key, 'data-variant-id': item.variant_id || item.id });
        const src = item.image || item.featured_image?.url;
        if (src) {
          const photo = element('a', 'bag-item-image', undefined, { href: item.url, 'aria-label': item.product_title });
          photo.append(element('img', '', undefined, { src, alt: '', width: 120, height: 120, loading: 'lazy' }));
          row.append(photo);
        }
        const info = element('div');
        const link = element('a', '', undefined, { href: item.url }); link.append(element('strong', '', item.product_title)); info.append(link);
        if (item.variant_title && item.variant_title !== 'Default Title') info.append(element('p', '', item.variant_title));
        if (item.selling_plan_allocation) info.append(element('p', '', item.selling_plan_allocation.selling_plan.name));
        Object.entries(item.properties || {}).forEach(([key, value]) => { if (value && !key.startsWith('_')) info.append(element('p', '', key + ': ' + value)); });
        info.append(element('p', '', money(item.final_line_price)));
        (item.line_level_discount_allocations || []).forEach(discount => info.append(element('p', '', discount.discount_application.title + ' (−' + money(discount.amount) + ')')));
        const quantityRule = item.quantity_rule || rules.get(String(item.variant_id || item.id)) || { min: 1, increment: 1 };
        const min = Number(quantityRule.min) || 1, step = Number(quantityRule.increment) || 1;
        const actions = element('div', 'bag-item-actions'), quantity = element('div', 'bag-quantity', undefined, { 'data-bag-quantity': '' });
        const minus = element('button', '', '−', { type: 'button', 'data-quantity-step': -1, 'aria-label': 'Decrease quantity of ' + item.product_title });
        minus.disabled = item.quantity <= min;
        const input = element('input', '', undefined, { id: 'Quantity-' + current.dataset.sectionId + '-' + (index + 1), name: 'updates[]', 'data-saved-quantity': item.quantity, type: 'number', min, step, value: item.quantity, 'aria-label': 'Quantity for ' + item.product_title });
        if (quantityRule.max) input.max = quantityRule.max;
        const plus = element('button', '', '+', { type: 'button', 'data-quantity-step': 1, 'aria-label': 'Increase quantity of ' + item.product_title });
        plus.disabled = !!quantityRule.max && item.quantity >= Number(quantityRule.max);
        quantity.append(minus, input, plus);
        const removeURL = new URL(route('cart/change'), location.origin); removeURL.searchParams.set('line', String(index + 1)); removeURL.searchParams.set('quantity', '0');
        const remove = element('a', 'bag-remove', undefined, { 'data-cart-remove': '', href: removeURL.pathname + removeURL.search, 'aria-label': 'Remove ' + item.product_title + ' from cart' });
        remove.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg>';
        actions.append(quantity, remove); info.append(actions); row.append(info); form.append(row);
      });
      (cart.cart_level_discount_applications || []).forEach(discount => form.append(element('p', '', discount.title + ' (−' + money(discount.total_allocated_amount) + ')')));
      const total = element('div', 'total'); total.append(element('strong', '', labels.subtotalLabel), element('strong', '', money(cart.total_price) + ' ' + cart.currency));
      form.append(total, element('p', '', labels.shippingNote));
    }
    const productIds = new Set(cart.items.map(item => String(item.product_id)));
    current.querySelectorAll('[data-product-id]').forEach(card => { if (productIds.has(card.dataset.productId)) card.remove(); });
    window.resetPocketConveyors?.(current);
    if (!current.querySelector('.more-products [data-quick-card]')) current.querySelector('.more-products')?.remove();
  }

  function display(cart) {
    captureRules(); counts(cart);
    roots().forEach(current => renderFromCart(cart, current));
    checkoutState();
    document.dispatchEvent(new CustomEvent('pocket:cart-updated', { detail: { cart } }));
  }
  async function refresh(version = ++viewVersion) {
    const response = await fetch(route('cart.js'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('The cart display is unavailable.');
    const cart = await response.json();
    if (version === viewVersion) display(cart);
  }
  async function renderResponse(response) {
    const version = ++viewVersion;
    // Shopify renders this section in the same add request, as in Dawn's
    // bundled section rendering. Its result is for display, never permission to add.
    const html = response.sections?.['pocket-cart-state'];
    if (html) {
      try {
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pocket-cart-state]');
        if (node) { display(JSON.parse(node.textContent)); return; }
      } catch (error) { console.warn('Cart section rendering:', error); }
    }
    // A section can be unavailable in a draft. Refresh the display once, after
    // the successful add. A display failure never blocks another add.
    if (Array.isArray(response.items) && typeof response.item_count === 'number') display(response);
    else await refresh(version);
  }
  function feedback(form) {
    const pocket = form.closest('.quick-pocket');
    const status = pocket?.querySelector('.quick-status') || form.querySelector('[data-product-add-status]');
    return (text, error = false) => {
      if (status) {
        status.textContent = text; status.setAttribute('role', error ? 'alert' : 'status');
        if (error) status.append(' ', element('a', '', 'View cart', { href: route('cart') }));
      }
      notice(text, error);
    };
  }
  function add(form, choice) {
    if (form.dataset.busy || choice?.disabled) return;
    const quick = form.matches('[data-quick-add]'), say = feedback(form);
    const body = new FormData(form);
    if (quick && choice) { body.set('id', choice.value); body.set('quantity', choice.dataset.quantity || body.get('quantity') || '1'); }
    if (!body.has('quantity')) body.set('quantity', '1');
    body.set('sections', 'pocket-cart-state');
    body.set('sections_url', window.location.pathname);
    form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
    const restore = disableForm(form); say('Adding…');
    return mutate(async () => {
      try {
        const response = await post('cart/add.js', body);
        say('Added to your cart!');
        const disclosure = form.closest('.quick-disclosure'); if (disclosure) disclosure.open = false;
        renderResponse(response).catch(error => console.warn('Cart display refresh:', error));
        window.PocketBagDrawer?.open(choice || form.querySelector('[data-add-button]'), false);
      } catch (error) {
        say(error instanceof TypeError ? 'Connection interrupted. Open your cart before trying again.' : error.message, true);
      }
    }).finally(() => { restore(); delete form.dataset.busy; form.removeAttribute('aria-busy'); checkoutState(); });
  }
  function change(input, quantity) {
    if (pending || !input.closest('[data-cart-section]') || !Number.isSafeInteger(quantity) || quantity < 0) return;
    if (Number(input.dataset.savedQuantity) === quantity) return;
    const row = input.closest('[data-cart-line]'), body = new FormData();
    body.set('id', row.dataset.lineKey); body.set('quantity', String(quantity));
    const restore = disableForm(input.closest('[data-cart-content]'));
    notice('Updating your cart…');
    return mutate(async () => {
      try {
        const cart = await post('cart/change.js', body);
        viewVersion++; display(cart);
        notice(quantity === 0 ? 'Item removed.' : 'Cart updated.');
      } catch (error) {
        input.value = input.dataset.savedQuantity;
        notice(error instanceof TypeError ? 'Connection interrupted. Please reload your cart.' : error.message, true);
      }
    }).finally(() => { restore(); checkoutState(); });
  }
  window.PocketCart = { version: 'persistent-checkout-apps-1', refresh, get busy() { return pending > 0; } };
  window.refreshPocketCart = refresh;
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('[data-quick-add],[data-pocket-product-form]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const choices = form.querySelectorAll('button[name="id"]:not(:disabled)');
      add(form, event.submitter || (choices.length === 1 ? choices[0] : null));
    } else if (form.matches('[data-cart-form]') && (pending || event.submitter?.name !== 'checkout')) event.preventDefault();
  }, true);
  document.addEventListener('click', event => {
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      event.preventDefault(); if (stepper.disabled || pending) return;
      const input = stepper.closest('[data-bag-quantity]').querySelector('input');
      const step = Number(input.step) || 1, min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity;
      change(input, Math.max(min, Math.min(max, Number(input.value) + Number(stepper.dataset.quantityStep) * step))); return;
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) { event.preventDefault(); change(remove.closest('[data-cart-line]').querySelector('[name="updates[]"]'), 0); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-form] [name="updates[]"]') && event.target.reportValidity()) change(event.target, Number(event.target.value));
  });
  window.addEventListener('pageshow', event => { if (event.persisted && !pending) refresh().catch(error => console.warn('Cart display refresh:', error)); });
})();
